import { t } from '@lingui/macro';

import { FORMATTER_TYPES } from '../../../utilities/FormattingUtilities';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { formatMaintenanceEntityList } from './MaintenanceWindowsUtils';
import { AdminPages, buildPageTarget } from '../AdminLinkUtils';
import { formatTags } from '../../../utilities/StringUtilities';

export const MAINTENANCE_WINDOW_NAME_FIELD = 'name';
export const MAINTENANCE_WINDOW_DESCRIPTION_FIELD = 'description';
export const MAINTENANCE_WINDOW_START_TIME_FIELD = 'startTime';
export const MAINTENANCE_WINDOW_END_TIME_FIELD = 'endTime';
export const MAINTENANCE_WINDOW_BUSINESS_SERVICES_FIELD = 'businessServices';
export const MAINTENANCE_WINDOW_SITES_FIELD = 'sites';

export const MAINTENANCE_WINDOW_LIST_COLUMNS = [
    {
        type: COLUMN_TYPES.LINK,
        mapping: MAINTENANCE_WINDOW_NAME_FIELD,
        title: t`Name`,
        width: 160,
        sortable: true,
        link: {
            target: buildPageTarget(AdminPages.MaintenanceWindows),
        },
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: MAINTENANCE_WINDOW_DESCRIPTION_FIELD,
        title: t`Description`,
        width: 400,
        maxWidth: 800,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: MAINTENANCE_WINDOW_START_TIME_FIELD,
        title: t`Start Time`,
        width: 220,
        sortable: true,
        formatter: FORMATTER_TYPES.DATETIME,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: MAINTENANCE_WINDOW_END_TIME_FIELD,
        title: t`End Time`,
        width: 220,
        sortable: true,
        formatter: FORMATTER_TYPES.DATETIME,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: MAINTENANCE_WINDOW_BUSINESS_SERVICES_FIELD,
        title: t`Business Services`,
        width: 320,
        formatter: formatMaintenanceEntityList,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: MAINTENANCE_WINDOW_SITES_FIELD,
        title: t`Sites`,
        width: 320,
        formatter: formatMaintenanceEntityList,
    },
];

export const MAINTENANCE_WINDOW_SITES_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'name',
        title: t`Name`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'description',
        title: t`Description`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'tags',
        title: t`Tags`,
        sortable: false,
        formatter: formatTags,
        width: 240,
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        mapping: 'deviceCount',
        title: t`Device Count`,
        width: 140,
        sortable: false,
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        mapping: 'agents',
        title: t`nPoint Count`,
        width: 140,
        sortable: false,
        formatter: (agentList) => agentList?.length || 0,
    },
];

export const MAINTENANCE_WINDOW_BUSINESS_SERVICES_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'name',
        title: t`Name`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'description',
        title: t`Description`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'tags',
        title: t`Tags`,
        sortable: false,
        formatter: formatTags,
        width: 240,
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        mapping: 'deviceCount',
        title: t`Device Count`,
        width: 140,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        mapping: 'tests',
        title: t`Test Count`,
        width: 140,
        sortable: false,
        formatter: (testList) => testList?.length || 0,
    },
];
